import '../App.css';
import React from 'react';
import { motion } from 'framer-motion';
import Radium, { StyleRoot } from 'radium'

const containerVariants = {
    hidden: {
        opacity:0
    },
    visible: {
        opacity:1,
        transition: {
            staggerChildren:3
        }
    }
}

const mainVariants = {
    hidden: {
        opacity:0
    },
    visible: {
        opacity:1
    }
}

const nameVariants = {
    hidden:{
        opacity:0,
        y:-40
    },
    visible:{
        opacity:1,
        y:0,
        transition: {
            duration: 1,
            ease: 'easeOut',
        }
    }
}

const subVariants = {
    hidden:{
        opacity:0,
        y:40
    },
    visible:{
        opacity:1,
        y:0,
        transition: {
            duration: 1,
            ease: 'easeOut'
        }
    }
}

const scrollVariants = {
    visible: {
        y:-10,
        transition: {
            duration: 1,
            repeat: Infinity,
            repeatType:'reverse'
        }
    }
}

const logoVariants = {
    hidden:{
        opacity: 0,
        pathLength: 0,
    },
    visible: {
        opacity: 1,
        pathLength: 1,
        transition: {
            duration: 5,
            ease: 'easeInOut',
            repeat: Infinity,
            repeatType:'reverse'
        }
    }
}

const style = {
    nameContainer: {
        position: 'absolute',
        top: '35vh',
        left: '0px',
        right: '0px',
    },
    nameOne: {
        fontFamily: 'Otomanopee One',
        fontSize: '8vw',
        marginBottom: '0px',
        color: '#834bff',
    }
}

function Landing() {
    return (
        <StyleRoot>
        <motion.div
            variants={containerVariants}
            initial="hidden"
            animate="visible"
            style={{
                height: '100vh',
                backgroundColor:'black'
            }}>
            
            
            <svg
        className="svg"
                width="100%" height="50vh" viewBox="0 0 360 287" fill="none" xmlns="http://www.w3.org/2000/svg">
                <motion.path variants={logoVariants} d="M159.813 175.622L159.816 175.62C184.881 155.237 197.851 133.371 197.851 110.012C197.851 99.6655 193.957 91.34 186.14 85.3221C178.753 79.1557 169.941 76.091 159.835 76.091C155.206 76.091 147.73 77.5592 137.628 80.3134L137.597 80.322L137.565 80.3313C132.066 81.9854 127.559 83.7621 124.23 85.7276C123.963 82.6915 123.413 80.1219 122.514 78.0943C121.828 76.5486 120.89 75.2029 119.61 74.2412C118.3 73.2562 116.775 72.7836 115.14 72.7836C114.035 72.7836 112.039 73.125 109.445 73.6624L109.288 73.695L109.136 73.7474C105.867 74.8763 102.202 77.3997 98.1783 81.0226C94.1151 84.6816 89.5151 89.6216 84.3842 95.806C74.1203 108.177 61.5903 125.7 46.8035 148.334L46.8017 148.337C32.1352 170.853 21.0915 190.085 13.706 206.014C6.35162 221.876 2.5 234.72 2.5 244.378C2.5 263.307 8.2529 276.797 20.5268 283.761L20.5682 283.785L20.6106 283.806C21.5961 284.317 22.6848 284.5 23.7558 284.5C24.7364 284.5 25.5988 284.05 26.1268 283.738C26.7163 283.389 27.3538 282.92 28.0239 282.37C28.9448 281.765 29.7744 280.917 30.1968 279.75C30.6506 278.496 30.5035 277.239 30.0785 276.138L30.0037 275.945L29.898 275.766C24.9 267.317 22.6642 260.91 22.6642 256.367C22.6642 245.599 26.352 232.349 33.9848 216.531C37.8203 208.722 41.2356 202.433 44.2321 197.642C46.3948 194.183 48.287 191.591 49.9066 189.782C55.9858 196.94 61.7796 201.636 67.3092 203.355L67.3254 203.36L67.3417 203.364C73.2924 205.126 82.3745 205.948 94.3891 205.948C113.345 205.948 135.19 195.587 159.813 175.622ZM125.414 100.27L125.454 100.25L125.493 100.229C134.948 95.1991 145.448 92.6672 157.041 92.6672C162.718 92.6672 166.508 93.9159 168.863 95.9763C171.155 97.9809 172.499 101.12 172.499 105.878C172.499 127.848 162.327 147.302 141.501 164.296C120.331 181.292 102.946 189.372 89.2014 189.372C82.0393 189.372 74.861 188.181 67.6572 185.783C60.8595 183.433 58.5795 180.338 58.5795 176.988C58.5795 175.989 59.0112 174.334 60.2371 171.877C61.4343 169.476 63.2707 166.54 65.7887 163.051C70.8219 156.075 78.4241 147.101 88.6386 136.106C98.8694 125.094 107.083 116.586 113.289 110.566C116.394 107.555 118.974 105.188 121.04 103.449C123.154 101.67 124.582 100.675 125.414 100.27ZM325.342 16.1627H325.425H327.925C327.925 12.197 325.965 8.90762 322.586 6.34567C319.487 3.79308 315.878 2.5 311.857 2.5C302.551 2.5 291.813 8.97619 279.786 20.6755C267.636 32.4941 253.691 50.1226 237.954 73.473L237.948 73.4811C222.353 96.8185 210.613 116.561 202.762 132.69C194.953 148.732 190.837 161.502 190.837 170.787C190.837 181.998 192.615 190.835 196.518 196.939C200.544 203.234 206.663 206.361 214.487 206.361C230.225 206.361 245.834 198.927 261.28 184.61L261.289 184.601L261.298 184.593C275.343 171.318 286.471 155.832 294.675 138.152C302.533 154.931 312.933 164.191 326.223 164.191C336.317 164.191 345.606 158.477 354.106 147.966L354.16 147.9L354.208 147.83C355.338 146.222 356.217 144.702 356.78 143.286C357.307 141.96 357.624 140.554 357.454 139.178C357.429 137.98 357.161 136.663 356.283 135.602C355.284 134.394 353.883 133.972 352.561 133.972C350.052 133.972 347.95 135.719 346.268 137.744C338.671 146.423 332.267 150.096 327.022 150.096C322.15 150.096 317.95 147.354 314.5 140.742C311.215 133.668 309.225 128.012 308.421 123.713C309.222 120.22 310.629 115.074 312.658 108.243L312.683 108.157L312.702 108.07C314.851 98.3327 315.954 90.1437 315.954 83.5522C315.954 80.1292 315.35 77.1188 313.872 74.7762C312.339 72.3478 310.019 70.8812 307.149 70.3493C305.706 70.0517 304.344 69.8896 303.078 69.8896C296.637 69.8896 291.618 72.6735 288.36 78.1377C285.225 83.3975 283.818 90.9651 283.818 100.503C283.818 108.876 284.693 116.08 286.509 122.056C283.571 132.734 275.908 146.09 263.227 162.182C255.472 171.437 248.297 178.273 241.708 182.78C235.106 187.295 229.243 189.372 224.064 189.372C222.489 189.372 221.253 188.997 220.253 188.337C219.255 187.68 218.339 186.638 217.567 185.06C216.084 181.455 215.391 178.222 215.391 175.334C215.391 169.501 217.299 162.228 221.347 153.434C225.384 144.666 231.476 134.538 239.669 123.039C256.116 99.9528 272.82 78.8012 289.782 59.581C307.017 40.3519 317.543 28.4808 321.321 24.0106C323.299 21.8252 324.764 20.241 325.728 19.2426C326.221 18.7318 326.543 18.4159 326.721 18.2554C326.84 18.1494 326.792 18.205 326.652 18.2924C326.605 18.3211 326.509 18.3787 326.375 18.4374C326.268 18.484 325.976 18.6048 325.574 18.6325C325.148 18.662 324.308 18.5922 323.621 17.8799C323.612 17.8712 323.604 17.8625 323.596 17.8538C324.556 16.8463 325.138 16.2826 325.342 16.1627Z" stroke="white" stroke-width="5"/>
            </svg>          
            
            
                <motion.div
                    variants={mainVariants}
                    style={style.nameContainer}>
                        <motion.div
                            variants={nameVariants}
                            className="my-name">
                            Priyanshu Bhardwaj
                        </motion.div>
                
                        <motion.div
                            variants={subVariants}
                            className="sub-name">
                            front-end developer                        
                        </motion.div>
                
                </motion.div>
            
                <motion.div
                    variants={mainVariants}
                    className="scroll">
                    <motion.div
                        variants={scrollVariants}>
                        scroll up
                    </motion.div>
                </motion.div>
        
            </motion.div>
        </StyleRoot>
    )
}

export default Radium(Landing)
